import { onCleanup, type JSX } from "solid-js";

type FilterDropdownProps = {
  open: boolean;
  /** Called when a click lands outside the dropdown. */
  onDismiss: () => void;
  /** Extra classes on the container, e.g. `app-switcher`. */
  class?: string;
  /** Extra classes on the panel, e.g. `filter-panel-wide`. */
  panelClass?: string;
  trigger: JSX.Element;
  children: JSX.Element;
};

/**
 * The popover used by the app switcher and by each view's filter panel.
 * Visibility is driven by the `open` class on the container, which the stylesheet
 * keys off; open state stays with the caller so its trigger can react to it.
 */
export function FilterDropdown(props: FilterDropdownProps) {
  let container!: HTMLDivElement;

  const onDocumentClick = (event: MouseEvent) => {
    if (props.open && !container.contains(event.target as Node))
      props.onDismiss();
  };
  document.addEventListener("click", onDocumentClick);
  onCleanup(() => document.removeEventListener("click", onDocumentClick));

  return (
    <div
      ref={container}
      class={`filter-dropdown ${props.class ?? ""}`}
      classList={{ open: props.open }}
    >
      {props.trigger}
      <div class={`filter-panel ${props.panelClass ?? ""}`}>
        {props.children}
      </div>
    </div>
  );
}
